import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';

import { queryClient } from '~app/query-client';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface DropEventParams {
  eventId: string;
  studentId: string;
  /** location Id in backend */
  studioId: string;
  droppingReason: string;
}

export const dropEventAPI = async (body: DropEventParams) => {
  const resp = await baseAPI.post<unknown>(
    `payment-processor/subscription/cancel-event`,
    {
      eventId: body.eventId,
      studentId: body.studentId,
      locationId: body.studioId,
      droppingReason: body.droppingReason,
    },
  );
  return resp.data;
};

export const useDropEventMutation = () => {
  return useMutation({
    mutationFn: async (body: DropEventParams) => {
      const response = await dropEventAPI(body);
      return response;
    },

    onSuccess: (_, body) => {
      // Invalidate individual student details
      void queryClient.invalidateQueries({
        queryKey: [KEYS.STUDENTS, body.studentId],
      });
      // Invalidate enrolled students list for this event
      // (matches query key in get-enrolled-active-students-by-event-id.ts)
      void queryClient.invalidateQueries({
        queryKey: [KEYS.STUDENTS, body.eventId],
      });
      // Invalidate all event-related queries
      void queryClient.invalidateQueries({
        predicate: (query) =>
          query.queryKey[0] === KEYS.EVENTS,
      });
      // Dropping can cancel/adjust event invoices → refresh Dashboard V2 AR
      void queryClient.invalidateQueries({ queryKey: [KEYS.ACCOUNTS_RECEIVABLE] });
      void queryClient.invalidateQueries({
        queryKey: [KEYS.ACCOUNTS_RECEIVABLE_DUE_DATE_GROUPING],
      });
      void queryClient.invalidateQueries({
        queryKey: [KEYS.ACCOUNTS_RECEIVABLE_STUDENT_GROUPING],
      });
      toast.success('Event dropped successfully');
    },
  });
};
